import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, LeftBackButtonText, H1Text, Hr, Text, Img, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { axiosLoginInstance, BASE_URLS, getRecaptchToken } from "../../api";
import { EMAIL, TOKENS } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";
import ReCAPTCHA from 'react-google-recaptcha';

type Props = {
    history: {
        push: Function,
    },
}

const Login = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly, setReadOnly] = useState([]);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const publicKey = localStorage.getItem('publicKey');
    const [showPassword, setShowPassword] = useState(false);
    const [sitekey, setSitekey] = useState();
    const [recaptchaToken, setRecaptchToken] = useState(null);
    const [isLogin, setIsLogin] = useState(false);
    const [showCaptchError, setShowCaptchError] = useState(null);

    const { handleSubmit, errors, control } = useForm();

    useEffect(() => {
        getRecaptha();
    }, []);

    const getRecaptha = async () => {
        try {
            const value = await getRecaptchToken();
            if (value) {
                setSitekey(value.siteKey);
                setIsLogin(value.login);
            }
        } catch (reason) {
            console.log(reason);
        }
    };

    const onSubmit = async (data) => {
        if (recaptchaToken) {
            setShowCaptchError(null);
        } else {
            setShowCaptchError('Captcha is required');
        }
        localStorage.setItem('email', data.email.trim());
        if (isLogin === true) {
            if (recaptchaToken) {
                try {
                    const { data: { entity } } = await axiosLoginInstance.post(BASE_URLS.AUTHENTICATE, {
                        email: data.email.trim(),
                        password: data.password,
                        recaptchaToken,
                        platformType: 'WEB',
                    });
                    if (entity.token) {
                        localStorage.setItem(TOKENS.ACCESS_TOKEN, entity.token.accessToken);
                        localStorage.setItem(TOKENS.REFRESH_TOKEN, entity.token.refreshToken);
                        setSuccess(true);
                    } else {
                        localStorage.setItem(TOKENS.SESSION_TOKEN, entity.session);
                        if (entity.challengeName === 'NEW_PASSWORD_REQUIRED') {
                            props.history.replace('/setuppassword');
                        }
                    }
                } catch (e) {
                    setShowErrorMessage(true);
                    setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
                }
            }
        } else {
            try {
                const { data: { entity } } = await axiosLoginInstance.post(BASE_URLS.AUTHENTICATE, {
                    email: data.email.trim(),
                    password: data.password,
                });
                if (entity.token) {
                    localStorage.setItem(TOKENS.ACCESS_TOKEN, entity.token.accessToken);
                    localStorage.setItem(TOKENS.REFRESH_TOKEN, entity.token.refreshToken);
                    setSuccess(true);
                } else {
                    localStorage.setItem(TOKENS.SESSION_TOKEN, entity.session);
                    if (entity.challengeName === 'NEW_PASSWORD_REQUIRED') {
                        props.history.replace('/setuppassword');
                    }
                }
            } catch (e) {
                setShowErrorMessage(true);
                setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
            }
        }
    }

    useEffect(() => {
        if (success) {
            props.history.replace('/partner-business');
        }
    }, [success]);

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => { props.history.push(`/connect/create?key=${btoa(publicKey)}`); }}
                        >
                            Back
                        </LeftBackButtonText>
                        <H1Text>
                            Configure Payments
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        ACCOUNT SETUP
                    </H1Text>

                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        Sign in to your account
                    </Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                {/* register your input into the hook by invoking the "register" function */}

                                <LabelText className="mt-4 mb-2">
                                    Email
                                </LabelText>
                                <Controller
                                    marginBottom="0px"
                                    defaultValue={""}
                                    control={control}
                                    name="email"
                                    placeholder="Enter your email address"
                                    rules={{
                                        required: 'Email is required',
                                        pattern: {
                                            value: EMAIL.DEFAULT_REGEX,
                                            message: EMAIL.DEFAULT_ERROR_MESSAGE,
                                        },
                                    }}
                                    as={<Input readOnly={readOnly && readOnly.includes("email")} />}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="email"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <LabelText className="mt-4 mb-2">
                                    Password
                                </LabelText>
                                <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                                    <Controller
                                        defaultValue={""}
                                        control={control}
                                        color={errors.password ? "red" : "inherit"}
                                        border="0px !important"
                                        name="password"
                                        placeholder="Enter your Password"
                                        rules={{
                                            required: 'Password is required'
                                        }}
                                        as={<Input style={{
                                            marginTop: "0",
                                            marginBottom: "0px",
                                            width: "268px",
                                        }}
                                            type={showPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("password")} />}
                                    />
                                    <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                                </InputWrapper>
                                <ErrorMessage
                                    errors={errors}
                                    name="password"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                {
                                    sitekey && (isLogin === true) && (
                                        <div className="mt-2">
                                            <ReCAPTCHA
                                                sitekey={sitekey}
                                                value={recaptchaToken}
                                                onChange={(value) => {
                                                    setRecaptchToken(value);
                                                    setShowCaptchError(null);
                                                }}
                                            />
                                            {
                                                (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                                                ) : showCaptchError ? (
                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                                                ) : ''
                                            }
                                        </div>
                                    )
                                }
                                <Text className="pt-4 text-center">
                                    <span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => props.history.push('/forgotpassword')}>Forgot password?</span>
                                </Text>
                                <div>
                                    <SubmitButton
                                        type="submit"
                                        marginTop="4px"
                                        style={{ width: '292px' }}
                                    >SIGN IN <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                </div>
                                {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                            </form>
                        </FlexContainer>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default Login;
